import API from '../stores/API'

export type QuickActionType =
  | 'sample-details'
  | 'component-changeout'
  | 'unit-meter-changeout'
  | 'unit-details'
  | 'unit-note'

export interface QuickActionRequest {
  actionType: QuickActionType
  sampleNumber?: number
  unitId?: number
  componentId?: number
  notes: string
  workOrderNumber?: string
  details?: Record<string, string>
}

export const quickActionApi = {
  create: async (request: QuickActionRequest) => {
    const response = await API.post('/quick-actions', request)
    return response.data
  }
}

export default quickActionApi
